var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCloseLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "57D6B322-6CF7-41BE-80FB-9815581B36B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal---Login",
    transform: "translate(-370.000000, -90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.750000, 90.656250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-close-line",
    transform: "translate(360.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32.25 0 32.25 32.25 0 32.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4F6F8",
    fillRule: "nonzero",
    points: "16.125 14.2249375 22.7765625 7.573375 24.676625 9.4734375 18.0250625 16.125 24.676625 22.7765625 22.7765625 24.676625 16.125 18.0250625 9.4734375 24.676625 7.573375 22.7765625 14.2249375 16.125 7.573375 9.4734375 9.4734375 7.573375"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCloseLine);
export default __webpack_public_path__ + "static/media/white-close-line.1c16c938f123924337f6e585277ccce8.svg";
export { ForwardRef as ReactComponent };